import React from 'react'
import { Link } from 'react-router-dom'

const SubmenuItem = ({ item }) => {

	const isActive = () => {
        let active = false

        if (window) {
            if (window.location.pathname.includes(item.url)) {
                active = true
            }
        }

        return active
    }

  return (
    <li>
        <Link
            to={item.url}
            className={isActive() ? 'active' : ''}
        >
            {item.ico ? item.ico : ''}
            <span>{ item.name }</span>
        </Link>
    </li>
  )
}

export default SubmenuItem